import React from 'react';
import { FormattedMessage } from 'react-intl';
import { takeEvery, put, call } from 'redux-saga/effects';

import {
  coursewareMetaInfoGetRequest,
  coursewareMetaInfoGetSuccess,
  coursewareMetaInfoGetError,
} from 'Workspace/Courseware/store/actions';
import { pushToast } from 'containers/ToastManager/actions';
import catchErrors from 'utils/commands/catchErrors';

import messages from '../messages';
import * as constants from '../constants';

export function* sendRequest(connection, action) {
  const { elementId, elementType, key } = action;

  yield put(coursewareMetaInfoGetRequest(elementId, key));
  const workspaceCoursewareMetaInfoGet = yield call(connection.fetch.bind(connection), {
    type: constants.RTM_WORKSPACE_COURSEWARE_META_INFO_GET,
    elementId,
    elementType,
    key,
  });

  if (workspaceCoursewareMetaInfoGet.type === constants.RTM_WORKSPACE_COURSEWARE_META_INFO_GET_OK) {
    const coursewareElementMetaInformation = workspaceCoursewareMetaInfoGet.response.coursewareElementMetaInformation;
    const { value } = coursewareElementMetaInformation;
    yield put(coursewareMetaInfoGetSuccess(elementId, key, value));
  } else {
    yield put(coursewareMetaInfoGetError(elementId, key));
    yield put(pushToast({
      type: 'simple',
      message: <FormattedMessage
        {...messages.failedWorkspaceCoursewareMetaInfoGet}
        values={{ key }}
      />,
    }));
  }
}

export default function* (connection) {
  yield takeEvery(constants.COMMAND_WORKSPACE_COURSEWARE_META_INFO_GET, catchErrors, sendRequest, connection);
}
